import * as _ from "lodash";
import * as $ from "jquery";

import { CanvasEventTool } from "../../tools/canvasEventTool";

export type CommentMarker = {
    position: THREE.Vector3;
    label: HTMLElement;
}

export class CommentViewerUtils {

    private viewer: Autodesk.Viewing.GuiViewer3D;
    private eventTool: CanvasEventTool;

    private onClickViewer;
    private onClickMarker;

    private markers: { [key: string]: CommentMarker; } = {};

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, onClickViewer: (pos: THREE.Vector3) => void, onClickMarker: (id: string) => void) {
        this.viewer = viewer;
        viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.onCameraChange);
        this.eventTool = new CanvasEventTool(this.viewer, this.onClickCanvas);
        viewer.toolController.registerTool(this.eventTool);
        this.viewer.toolController.activateTool(this.eventTool.getName());

        this.onClickViewer = onClickViewer;
        this.onClickMarker = onClickMarker;
    }

    onCameraChange = () => {
        for (let m of Object.keys(this.markers)) {
            this.updateMarkerPosition(this.markers[m]);
        }
    }

    onClickCanvas = (x: number, y: number, tap: boolean) => {
        const rect = this.viewer.canvas.getBoundingClientRect();
        const xe = x - (tap ? 0 : rect.left);
        const ye = y - (tap ? 0 : rect.top);

        const hit = (this.viewer as any).clientToWorld(xe, ye);
        if (hit != null) {
            const { x, y, z } = hit.point;
            const pointPos = new THREE.Vector3(x, y, z);
            this.onClickViewer(pointPos);
        }
    }

    clear() {
        for (let m of Object.keys(this.markers)) {
            this.viewer.container.removeChild(this.markers[m].label);
        }
        this.markers = {};
    }

    addCommentMarker(id: string, position: THREE.Vector3, text:string, selected: boolean = false) {
        const label = document.createElement("div");
        label.onclick = (e) => {
            this.onClickMarker(id);
            e.stopPropagation();
        };
        label.className = "comment-label visible " + (selected ? "comment-label-selected" : "");
        label.id = id;
        const labelIcon = document.createElement("div");
        labelIcon.className = "icon ion-md-qr-scanner comment-marker";
        label.appendChild(labelIcon);

        const labelIconInner = document.createElement("div");
        labelIconInner.className = "icon ion-md-qr-scanner comment-marker-inner";
        labelIcon.appendChild(labelIconInner);

        const labelText = document.createElement("div");
        labelText.className = "comment-text pl-1 pr-2";
        labelText.innerHTML = `<pre>${_.escape(text)}</pre>`;
        label.appendChild(labelText);

        this.markers[id] = { position: position, label: label };
        this.viewer.container.appendChild(label);

        this.onCameraChange();
    };

    removeCommentMarker(id: string) {
        const marker = this.markers[id];
        if (marker != null) {
            this.viewer.container.removeChild(marker.label);
            delete this.markers[id];
        }
    }

    removeAllCommentMarkers() {
        for (let cid of _.keys(this.markers)) {
            this.removeCommentMarker(cid);
        }
        $(".comment-label").remove();
    }

    updateCommentMarker(id: string, position: THREE.Vector3, text: string, selected: boolean = false) {
        this.removeCommentMarker(id);
        this.addCommentMarker(id, position, text, selected);
    }

    activate() {
        this.viewer.toolController.registerTool(this.eventTool);
        this.viewer.toolController.activateTool(this.eventTool.getName());
    }

    deactivate() {
        this.viewer.toolController.deactivateTool(this.eventTool.getName());
        this.viewer.toolController.deregisterTool(this.eventTool);
    }

    private updateMarkerPosition(marker: CommentMarker) {

        if (marker != null) {
            const label = marker.label;
            const point = marker.position;

            if (label && point) {
                const xy = this.project(point, this.viewer);

                xy.x = xy.x - label.getBoundingClientRect().width / 2;
                xy.y = xy.y - label.getBoundingClientRect().height / 2;

                label.style.top = xy.y + "px";
                label.style.left = xy.x + "px";
            }
        }
    }

    private project(point, viewer, offset ?) {
        const camera = viewer.navigation.getCamera();
        const containerBounds = viewer.navigation.getScreenViewport();
        let p = new THREE.Vector3(point.x, point.y, point.z);

        p = p.project(camera);

        offset = offset || 0;

        return new THREE.Vector2(Math.round((p.x + 1) / 2 * containerBounds.width) + offset,
            Math.round((-p.y + 1) / 2 * containerBounds.height) + offset);
    };
}